var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _circle3, _circle4, _circle5, _circle6, _path6, _path7, _path8, _path9, _path10, _path11, _circle7, _path12, _circle8, _path13, _circle9, _circle10, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle11, _circle12, _circle13, _path21, _path22, _path23, _path24, _circle14, _circle15, _circle16, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _path33, _circle27, _circle28, _path34, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _path35, _circle35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _ellipse, _path44, _path45, _path46, _path47, _path48, _ellipse2, _path49, _ellipse3, _path50, _path51, _ellipse4, _path52, _circle36, _ellipse5, _circle37, _path53, _path54, _path55, _path56, _path57, _path58, _circle38, _circle39, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _circle40, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _circle41, _circle42, _circle43, _path75, _path76, _path77, _path78, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _path79, _path80, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountSetupDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 441,
    viewBox: "0 0 311 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.847 317.638V439.588H219.694L231.159 345.039C232.801 331.486 244.305 321.293 257.957 321.294C271.61 321.289 283.116 331.484 284.754 345.039L296.219 439.63H310.108V295.135C310.111 284.298 305.807 273.904 298.145 266.241C290.483 258.577 280.091 254.272 269.254 254.272C252.442 254.263 236.315 260.935 224.423 272.819C212.531 284.703 205.849 300.825 205.847 317.638H205.847Z",
    fill: "#581B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.71 174.778C220.71 174.778 81.8929 222.744 24.2223 425.749L0 439.588H44.9891L150.928 290.161C150.928 290.161 201.52 284.013 229.886 275.559C269.121 263.875 220.71 174.778 220.71 174.778Z",
    fill: "#CCE3EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M220.71 174.778C220.71 174.778 81.8929 222.744 24.2223 425.749L0 439.588H44.9891L150.928 290.161C150.928 290.161 201.52 284.013 229.886 275.559C269.121 263.875 220.71 174.778 220.71 174.778Z",
    fill: "#CCE3EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.4467,
    cy: 390.28,
    r: 6.24849,
    fill: "#32B8ED"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.3706,
    cy: 421.405,
    r: 6.24849,
    fill: "#32B8ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1696 408.698C36.3749 407.927 37.6809 405.655 37.237 403.362C36.793 401.068 34.7335 399.448 32.3999 399.556C31.4717 402.285 30.5575 405.044 29.6572 407.834C30.9075 408.89 32.6178 409.217 34.1696 408.698Z",
    fill: "#9DC7D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3286 389.147C75.8189 389.651 74.6664 390.884 74.2652 392.424C73.8641 393.964 74.2688 395.603 75.3408 396.779L80.6499 389.281C79.596 388.834 78.4152 388.786 77.3286 389.147Z",
    fill: "#9DC7D1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.1284,
    cy: 396.712,
    r: 6.24849,
    fill: "#F275A8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.352,
    cy: 372.893,
    r: 6.24849,
    fill: "#F275A8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.3873,
    cy: 415.324,
    r: 3.65683,
    fill: "#1E2454"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0318,
    cy: 384.031,
    r: 1.9039,
    fill: "#1E2454"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2676 365.763C57.9229 372.934 71.3683 378.612 85.3334 382.681L150.93 290.161C150.93 290.161 201.522 284.013 229.887 275.559C269.123 263.875 220.712 174.778 220.712 174.778C220.712 174.778 110.025 213.04 45.2676 365.763Z",
    fill: "#CE3669"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6514 372.683L141.518 279.467L192.101 254.272",
    stroke: "#32B8ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.432 290.866L150.926 290.161C150.926 290.161 201.518 284.013 229.884 275.559C246.876 270.527 247.422 250.926 242.591 230.352C240.955 230.276 267.752 224.154 237.667 230.226C196.654 238.521 189.994 233.765 150.432 290.866Z",
    fill: "#1E2454"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M291.985 210.189C287.497 168.714 264.676 169.175 246.593 171.96C246.048 172.052 245.503 172.127 244.915 172.203C238.004 173.151 203.055 178.074 181.843 245.046C159.106 316.799 236.36 407.758 236.36 407.758L229.969 432.979L261.254 411.424L229.818 275.55C229.818 275.55 298.527 270.677 291.985 210.189Z",
    fill: "#CCE3EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M224.098 391.596C226.255 390.495 227.581 388.246 227.501 385.826C227.422 383.405 225.95 381.249 223.726 380.292C221.501 379.334 218.924 379.749 217.111 381.355C219.577 385.113 221.934 388.543 224.098 391.596Z",
    fill: "#32B8ED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M258.428 398.952C255.994 399.979 254.471 402.428 254.625 405.066C254.779 407.704 256.578 409.958 259.116 410.694C259.794 410.888 260.5 410.967 261.204 410.929L258.428 398.952Z",
    fill: "#32B8ED"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.642,
    cy: 396.436,
    r: 4.70524,
    fill: "#9DC7D1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M252.354 372.717C251.684 373.305 251.198 374.074 250.953 374.931C250.607 376.13 250.751 377.418 251.356 378.51C251.96 379.602 252.974 380.409 254.174 380.752H254.216L252.354 372.717Z",
    fill: "#9DC7D1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.471,
    cy: 379.795,
    r: 6.24849,
    fill: "#F275A8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M213.229 375.308C215.498 374.37 217.007 372.189 217.086 369.735C217.165 367.281 215.799 365.008 213.595 363.925C211.391 362.843 208.757 363.152 206.863 364.715C209.002 368.431 211.141 371.97 213.229 375.308Z",
    fill: "#F275A8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.205,
    cy: 392.729,
    r: 3.65683,
    fill: "#1E2454"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.143,
    cy: 373.958,
    r: 1.9039,
    fill: "#1E2454"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M259.918 166.625C259.373 166.709 236.97 175.575 236.434 175.65C229.523 176.598 203.103 178.108 181.917 245.046C169 285.8 188.358 332.751 207.489 365.722H250.784L229.925 275.559C229.925 275.559 312.338 268.79 300.244 209.157C296.855 192.701 278.001 163.874 259.918 166.625Z",
    fill: "#CE3669"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259.921 166.626C259.376 166.709 236.973 175.575 236.437 175.65C229.942 176.253 223.734 178.613 218.479 182.477C230.381 186.671 247.986 189.347 267.654 189.347C275.442 189.358 283.225 188.919 290.962 188.03C283.019 175.675 271.319 164.864 259.921 166.626Z",
    fill: "#1E2454"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.876 245.046C173.12 272.724 179.2 303.187 189.995 330.235",
    stroke: "#1E2454",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M198.273 71.1621L152.428 127.977L102.449 101.977L82.0007 99.4606L76.1296 90.9979H72.5315C72.0038 91.0013 71.5121 91.2657 71.2182 91.704C70.9244 92.1423 70.8665 92.6976 71.0637 93.187L75.7102 104.552C76.589 106.697 78.4738 108.268 80.7426 108.745L89.1885 110.498C93.9067 111.478 98.2613 113.745 101.769 117.049L137.054 150.262C146.874 159.499 161.89 160.406 172.751 152.418L219.719 117.879L198.273 71.1621Z",
    fill: "#FF92B9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M134.404 105.818L82.1014 99.4857L53.6436 45.9165",
    stroke: "#1E2454",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.275 71.1621L160.314 118.181C164.399 129.009 174.397 137.723 187.229 141.825L219.688 117.946L198.275 71.1621Z",
    fill: "#E8E8A3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M164.567 126.031C166.019 124.577 166.368 122.353 165.432 120.523C164.495 118.694 162.486 117.677 160.457 118.005L160.314 118.181C161.375 120.976 162.805 123.616 164.567 126.031Z",
    fill: "#C6DD85"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.578,
    cy: 122.71,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.994,
    cy: 122.71,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.783,
    cy: 136.683,
    r: 4.76395,
    fill: "#C6DD85"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M160.314 118.181C164.399 129.009 174.397 137.723 187.229 141.825",
    stroke: "#FFFECF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M214.931 107.563C202.241 108.117 192.101 120.144 192.101 134.989C192.099 136.037 192.152 137.084 192.26 138.126L219.686 117.946L214.931 107.563Z",
    fill: "#1E2454"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M273.154 147.176C286.331 132.918 296.555 110.272 300.203 83.9697L262.15 78.7109C253.263 83.7559 242.097 82.2083 234.917 74.9366L198.273 69.9043C193.819 102.103 200.37 131.626 213.781 148.568C217.898 153.762 218.385 160.958 215.006 166.659C211.416 172.707 208.925 178.15 216.918 181.597C232.921 188.525 278.514 183.224 278.514 172.447C278.514 168.807 276.333 164.328 272.861 160C269.764 156.244 269.889 150.786 273.154 147.176Z",
    fill: "#E8E8A3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M273.154 147.176C286.331 132.918 296.555 110.272 300.203 83.9697L262.15 78.7109C253.263 83.7559 242.097 82.2083 234.917 74.9366L198.273 69.9043C193.819 102.103 200.37 131.626 213.781 148.568C217.898 153.762 218.385 160.958 215.006 166.659C211.416 172.707 208.925 178.15 216.918 181.597C232.921 188.525 278.514 183.224 278.514 172.447C278.514 168.807 276.333 164.328 272.861 160C269.764 156.244 269.889 150.786 273.154 147.176Z",
    fill: "#E8E8A3"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.051,
    cy: 136.683,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.257,
    cy: 150.657,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.313,
    cy: 164.63,
    r: 4.76395,
    fill: "#C6DD85"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M266.864 178.603C266.865 176.307 265.228 174.337 262.97 173.917C260.713 173.498 258.477 174.749 257.654 176.892C256.83 179.036 257.652 181.462 259.609 182.662C261.933 182.209 264.13 181.689 266.16 181.094C266.621 180.345 266.865 179.482 266.864 178.603Z",
    fill: "#C6DD85"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M278.114 174.115C276.656 173.594 275.035 173.815 273.77 174.708C272.504 175.601 271.753 177.054 271.756 178.603C271.748 178.762 271.748 178.921 271.756 179.081C274.986 177.655 277.25 175.986 278.114 174.115Z",
    fill: "#C6DD85"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M245.233 80.8914C242.413 80.1504 239.764 78.8685 237.433 77.1172C235.739 78.5191 235.225 80.8984 236.188 82.8749C237.152 84.8515 239.343 85.9117 241.491 85.4407C243.639 84.9697 245.185 83.0898 245.233 80.8914Z",
    fill: "#C6DD85"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M250.196 81.6296C250.611 84.0793 252.839 85.7987 255.314 85.5793C257.789 85.3599 259.68 83.2754 259.657 80.7909C259.654 80.5093 259.626 80.2286 259.573 79.9521C256.603 81.1728 253.406 81.7447 250.196 81.6296H250.196Z",
    fill: "#C6DD85"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M202.586 127.113C204.896 128.075 207.557 127.087 208.678 124.85C209.799 122.613 208.998 119.89 206.845 118.616C204.692 117.341 201.919 117.95 200.498 120.009C201.119 122.45 201.815 124.823 202.586 127.113Z",
    fill: "#C6DD85"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M278.516 172.413C278.516 168.773 276.335 164.294 272.863 159.966C269.786 156.216 269.91 150.781 273.156 147.176",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M211.812 176.766C212.315 178.611 213.841 180.238 216.919 181.563C232.922 188.491 278.515 183.19 278.515 172.413",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M275.455 163.623C274.664 162.353 273.799 161.132 272.863 159.966C269.786 156.216 269.911 150.78 273.156 147.175C275.798 144.291 278.231 141.221 280.437 137.991C280.45 137.962 280.467 137.934 280.487 137.908C276.651 138.461 272.78 138.741 268.904 138.746C252.658 138.746 238.484 134.125 230.91 127.264C229.375 130.846 227.555 132.07 226.993 136.129C231.942 145.272 241.78 155.001 252.885 158.188C254.109 158.515 263.981 160.956 275.455 163.623Z",
    fill: "#1E2454"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.627,
    cy: 108.737,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.051,
    cy: 108.737,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.839,
    cy: 122.71,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.257,
    cy: 122.71,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.684,
    cy: 122.71,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.1,
    cy: 122.71,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.627,
    cy: 136.683,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.47,
    cy: 136.683,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.888,
    cy: 136.683,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.313,
    cy: 136.683,
    r: 4.76395,
    fill: "#C6DD85"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M223.603 150.656C223.603 148.304 221.886 146.303 219.56 145.946C217.234 145.59 214.997 146.985 214.293 149.231C215.516 150.963 216.387 152.917 216.859 154.984C218.33 155.647 220.036 155.519 221.391 154.645C222.747 153.771 223.567 152.269 223.569 150.656H223.603Z",
    fill: "#C6DD85"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.684,
    cy: 150.657,
    r: 4.76395,
    fill: "#293475"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.1,
    cy: 150.657,
    r: 4.76395,
    fill: "#293475"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M213.699 168.907C215.346 168.114 216.392 166.448 216.392 164.621C216.393 164.34 216.368 164.059 216.316 163.782C215.971 164.761 215.533 165.705 215.008 166.6C214.549 167.389 214.113 168.158 213.699 168.907Z",
    fill: "#C6DD85"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.051,
    cy: 164.63,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.47,
    cy: 164.63,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.888,
    cy: 164.63,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.839,
    cy: 178.603,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.257,
    cy: 178.603,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.684,
    cy: 178.603,
    r: 4.76395,
    fill: "#C6DD85"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M310.879 147.704L303.632 92.9272L273.128 109.777L277.556 127.39C277.597 127.547 277.55 127.713 277.433 127.824C277.317 127.936 277.149 127.975 276.995 127.927L243.966 118.642C239.25 117.318 235.251 114.178 232.844 109.911L230.538 105.818C230.262 105.305 229.728 104.984 229.145 104.98H228.483C227.795 104.979 227.136 105.26 226.661 105.758C226.185 106.255 225.935 106.926 225.967 107.613L226.134 112.025C226.144 112.297 226.009 112.553 225.779 112.698C225.549 112.843 225.26 112.855 225.019 112.729L208.932 104.435C207.876 103.864 206.574 104.037 205.703 104.862C205.16 105.403 204.873 106.15 204.915 106.916C204.957 107.681 205.323 108.392 205.921 108.871L215.558 116.562C216.247 117.107 216.713 117.886 216.866 118.752L218.158 125.772C219.133 131.014 222.665 135.42 227.569 137.514L289.382 163.942C294.5 166.116 300.389 165.39 304.826 162.038C309.262 158.687 311.57 153.221 310.879 147.704Z",
    fill: "#FF92B9"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.901,
    cy: 132.045,
    r: 6.67624,
    fill: "#E8E8A3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M245.837 138.034C243.591 139.146 240.911 138.896 238.909 137.388C239.046 139.278 239.421 141.143 240.025 142.94L247.229 146.018C246.292 143.493 245.817 140.819 245.829 138.126C245.827 138.095 245.83 138.064 245.837 138.034Z",
    fill: "#257ED6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M246.658 119.422C244.315 120.954 242.427 123.085 241.189 125.595C241.737 125.449 242.3 125.373 242.867 125.369C244.949 125.375 246.911 126.348 248.176 128.003C249.508 125.306 251.61 123.065 254.215 121.561L246.658 119.422Z",
    fill: "#257ED6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M247.205 146.018C246.267 143.493 245.793 140.82 245.804 138.126",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M248.213 128.011C249.545 125.314 251.647 123.073 254.252 121.569",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M218.144 125.83C219.119 131.072 222.65 135.479 227.554 137.572L274.816 157.777",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M306.235 112.595C302.268 108.183 294.217 105.164 284.949 105.164C283.674 105.164 282.433 105.223 281.208 105.332L273.156 109.777L277.585 127.39C277.619 127.53 277.582 127.677 277.487 127.784C277.391 127.892 277.249 127.945 277.107 127.927L285.855 130.393C290.411 131.725 295.29 131.428 299.652 129.554C303.334 127.919 306.152 125.688 307.653 123.113L306.235 112.595Z",
    fill: "#1E2454"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M198.735 113.115C199.897 119.935 201.76 126.616 204.296 133.052",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M225.86 2.043C224.874 1.90405 223.918 1.6007 223.033 1.14556C221.577 0.430211 219.983 0.0409459 218.361 0.00489975C212.549 -0.162845 207.718 3.99722 207.567 9.29795C207.523 10.8611 207.89 12.4084 208.632 13.7851C209.119 14.6575 209.437 15.6134 209.572 16.6032C210.41 22.9859 216.281 28.0434 223.536 28.2531C231.513 28.4795 238.138 22.7678 238.348 15.4961C238.541 8.71085 233.073 2.96559 225.86 2.043Z",
    fill: "#3B30A0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.272,
    cy: 32.438,
    rx: 9.59499,
    ry: 13.4363,
    transform: "rotate(-46.7 239.272 32.438)",
    fill: "#E8E8A3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M266.1 24.4283C264.507 23.7622 262.957 22.9946 261.462 22.1302C252.588 17.0392 231.218 18.096 224.223 34.1575C213.856 57.9857 239.924 62.2967 239.924 62.2967C246.893 64.4187 238.816 53.8591 237.24 53.1798L237.097 49.9088C246.903 49.3772 255.726 43.7821 260.388 35.1388C265.731 40.4647 265.035 55.2682 265.035 55.2682L265.672 55.8134C288.351 43.937 271.325 26.6174 266.1 24.4283Z",
    fill: "#3B30A0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M242.549 20.084C235.839 21.4763 229.323 25.0408 225.456 31.6248",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M257.135 32.9585C270.194 34.1746 267.2 45.5393 267.2 45.5393C266.257 49.2197 265.784 53.0043 265.791 56.8034C265.925 64.6203 262.629 69.552 255.835 70.4578C247.548 71.5649 240.302 67.3713 238.691 58.2963C238.507 57.2563 238.322 56.1995 238.088 55.1679C236.88 49.6575 234.322 30.8365 257.135 32.9585Z",
    fill: "#FF92B9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M240.017 62.5486C239.41 61.2106 238.973 59.8017 238.717 58.355C238.533 57.315 238.348 56.2582 238.113 55.2266",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M238.558 51.2508C242.273 50.8986 246.727 48.9024 251.088 46.1262C258.05 41.6978 262.495 35.6925 262.436 31.3563C260.97 30.7825 259.427 30.4292 257.857 30.3079C236.973 28.3621 237.4 44.3565 238.558 51.2508Z",
    fill: "#ED72A5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.376,
    cy: 37.8351,
    rx: 5.5859,
    ry: 13.1512,
    transform: "rotate(-30 262.376 37.8351)",
    fill: "#3B30A0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M255.241 27.0371H255.115C253.32 29.2346 254.276 34.9379 257.539 40.6076C258.202 41.7753 258.945 42.8962 259.762 43.9625C260.959 41.8557 261.567 39.4658 261.523 37.0431C261.523 31.5075 258.713 27.0371 255.241 27.0371Z",
    fill: "#1E2454"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.398,
    cy: 37.8289,
    rx: 18.2842,
    ry: 8.97434,
    transform: "rotate(-32.45 247.398 37.8289)",
    fill: "#3B30A0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M251.399 44.2058C249.736 43.7419 247.958 43.9529 246.45 44.7929",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M257.722 46.2856C257.487 47.5269 257.277 48.7011 257.135 49.8921C257.005 50.4866 256.962 51.097 257.009 51.7037C257.097 52.3067 257.324 52.8809 257.672 53.3812C257.837 53.6275 258.022 53.8603 258.225 54.0773C258.472 54.3446 258.658 54.6622 258.77 55.0083C258.87 55.4185 258.807 55.8516 258.594 56.2161C258.399 56.5358 258.136 56.808 257.822 57.0129C257.225 57.4049 256.512 57.5796 255.801 57.5077C255.111 57.4607 254.486 57.0826 254.124 56.4928C254.111 56.4753 254.111 56.4517 254.124 56.4341H254.174C254.641 56.781 255.226 56.9288 255.801 56.8451C256.343 56.7949 256.861 56.6009 257.302 56.2832C257.747 55.9561 258.066 55.5954 257.99 55.1844C257.924 54.9295 257.813 54.6882 257.663 54.4715C257.496 54.1901 257.358 53.8922 257.252 53.5825C257.038 52.9825 256.864 52.3689 256.732 51.7457C256.572 51.1218 256.471 50.4844 256.43 49.8418C256.441 48.5447 256.864 47.2848 257.638 46.2437C257.638 46.2437 257.722 46.2688 257.722 46.2856Z",
    fill: "#1E2454"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.518,
    cy: 50.8982,
    rx: 1.02324,
    ry: 1.14905,
    transform: "rotate(-2.24 261.518 50.8982)",
    fill: "#1E2454"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M259.618 45.1028C261.016 44.8392 262.46 45.1409 263.636 45.9416",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.816,
    cy: 55.6627,
    r: 1.81164,
    fill: "#FFBDD8"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.662,
    cy: 49.9882,
    rx: 1.08282,
    ry: 1.20873,
    transform: "rotate(-2.29061 249.662 49.9882)",
    fill: "#1E2454"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.097,
    cy: 54.4299,
    r: 1.91229,
    fill: "#FFBDD8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M257.93 55.5537C257.93 55.5537 257.587 56.3924 255.951 55.8221C254.492 55.3524 253.687 56.2331 254.316 56.7615C255.11 57.3609 256.174 57.4615 257.067 57.0215C257.452 56.7547 257.783 56.4158 258.04 56.0234",
    fill: "#1E2454"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M250.559 58.1953C251.045 58.3127 251.397 58.4553 251.808 58.5811L252.899 58.9502L253.989 59.3276C254.406 59.4663 254.815 59.6287 255.214 59.814C254.83 60.1058 254.369 60.2779 253.888 60.3089C253.418 60.3543 252.943 60.2971 252.496 60.1412C251.564 59.8598 250.836 59.1286 250.559 58.1953H250.559Z",
    fill: "#1E2454"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M232.947 50.5046C232.109 52.0814 232.838 56.166 238.978 56.166L239.817 53.9182C238.559 47.9213 234.398 47.7116 232.947 50.5046Z",
    fill: "#FF92B9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M239.01 56.166C232.871 56.166 232.183 52.0814 232.98 50.5046C234.246 47.9884 237.71 47.9046 239.379 52.182",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M234.995 51.4858C235.106 51.2558 235.316 51.0891 235.565 51.0328C235.819 50.9764 236.085 51.0059 236.32 51.1167C236.541 51.2181 236.729 51.3775 236.865 51.578C237.001 51.7686 237.085 51.9911 237.109 52.2238C236.664 52.0393 236.362 51.8129 236.052 51.687C235.726 51.5215 235.359 51.4517 234.995 51.4858Z",
    fill: "#1E2454"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M264.676 77.3772C259.912 81.0058 253.901 82.5929 247.966 81.7891C242.031 80.9853 236.659 77.8566 233.031 73.0913",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.836,
    cy: 80.7907,
    r: 14.4176,
    fill: "#E8E8A3"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.984,
    cy: 94.4367,
    r: 14.4176,
    fill: "#E8E8A3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M159.165 119.489L150.929 129.688",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M303.635 92.9272L269.675 106.498L275.328 124.111C280.36 124.589 284.092 124.782 287.967 124.782C294.55 124.802 301.121 124.207 307.593 123.004L303.635 92.9272Z",
    fill: "#E8E8A3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M276.56 117.946C275.527 117.946 274.522 118.285 273.7 118.911L275.378 124.103C277.416 124.295 279.244 124.446 280.972 124.555C281.215 123.971 281.34 123.344 281.341 122.71C281.341 121.444 280.837 120.23 279.94 119.336C279.043 118.442 277.827 117.942 276.56 117.946Z",
    fill: "#C6DD85"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M295.348 124.539C295.584 123.958 295.706 123.337 295.709 122.71C295.709 120.079 293.576 117.946 290.945 117.946C288.314 117.946 286.181 120.079 286.181 122.71C286.179 123.422 286.34 124.125 286.65 124.765H287.967C290.483 124.773 292.941 124.69 295.348 124.539Z",
    fill: "#C6DD85"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M300.599 122.71C300.598 123.162 300.663 123.611 300.792 124.044C303.157 123.775 305.438 123.423 307.619 123.004L306.981 118.231C306.463 118.042 305.915 117.945 305.363 117.946C304.099 117.946 302.887 118.448 301.994 119.342C301.101 120.235 300.599 121.447 300.599 122.71Z",
    fill: "#C6DD85"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M275.326 124.102C280.359 124.58 284.091 124.773 287.966 124.773C294.549 124.796 301.119 124.203 307.592 123.003",
    stroke: "#FFFECF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M217.253 118.583L217.404 120.261C217.529 121.458 218.201 122.529 219.224 123.163L220.063 123.691",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M217.899 123.457L218.05 125.134C218.172 126.332 218.845 127.405 219.87 128.036L220.709 128.573",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.901,
    cy: 132.045,
    r: 6.67624,
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M242.901 128.908V132.045H245.065",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M273.497 116.646L277.146 128.011",
    stroke: "#1E2454",
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4888 421.404C25.0611 422.847 24.6501 424.29 24.2224 425.749L0.469727 439.319L1.14909 439.588H44.9891L57.8803 421.404H25.4888Z",
    fill: "#9CC967"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14746 439.588H44.9875",
    stroke: "#1E2454",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M236.426 407.784L230.035 433.004L261.32 411.449L259.76 404.739H233.918C235.512 406.71 236.426 407.784 236.426 407.784Z",
    fill: "#9CC967"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M230.035 433.004L261.32 411.449",
    stroke: "#1E2454",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M266.98 193.23C266.98 201.617 275.158 208.419 285.239 208.419C285.239 208.419 304.127 252.754 210.19 270.174L242.297 361.042",
    stroke: "#7DFFF8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M202.836 66.3731C201.766 66.3774 200.701 66.4983 199.657 66.7337C199.657 66.7337 199.657 66.7924 199.657 66.8176C199.649 69.2621 201.493 71.316 203.924 71.5712C206.355 71.8265 208.585 70.2002 209.085 67.8073C207.138 66.8611 205.001 66.3706 202.836 66.3731Z",
    fill: "#C6DD85"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.209,
    cy: 80.7908,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.627,
    cy: 80.7908,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.051,
    cy: 80.7908,
    r: 4.76395,
    fill: "#C6DD85"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M269.314 85.5545C271.945 85.5545 274.078 83.4216 274.078 80.7906C274.086 80.6453 274.086 80.4997 274.078 80.3544L264.894 79.0796C264.682 79.6139 264.571 80.1825 264.567 80.757C264.558 82.0234 265.053 83.2412 265.944 84.1414C266.835 85.0416 268.047 85.5501 269.314 85.5545Z",
    fill: "#C6DD85"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M278.977 81.0338C279.128 83.5987 281.285 85.5817 283.854 85.516C286.422 85.4504 288.476 83.3598 288.496 80.7906C288.496 80.6731 288.496 80.5641 288.496 80.4551C287.258 80.7628 286.067 81.2368 284.957 81.8641L278.977 81.0338Z",
    fill: "#C6DD85"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M293.443 80.0859C293.407 80.3191 293.387 80.5545 293.385 80.7905C293.388 82.7846 294.632 84.566 296.503 85.2547C298.375 85.9434 300.477 85.3936 301.772 83.877C299.484 81.7388 296.559 80.4075 293.443 80.0859V80.0859Z",
    fill: "#C6DD85"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M175.576 99.5278C177.053 99.5327 178.447 98.8505 179.35 97.6819C180.252 96.5134 180.559 94.9915 180.181 93.5645L175.375 99.5194L175.576 99.5278Z",
    fill: "#C6DD85"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.994,
    cy: 94.7639,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.413,
    cy: 94.7639,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.839,
    cy: 94.7639,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.257,
    cy: 94.7639,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.684,
    cy: 94.7639,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.1,
    cy: 94.7639,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.518,
    cy: 94.7639,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.945,
    cy: 94.7639,
    r: 4.76395,
    fill: "#C6DD85"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M300.599 94.7638C300.599 97.3948 302.732 99.5277 305.363 99.5277H305.463C306.626 96.4778 306.712 93.122 305.706 90.0166H305.363C302.738 90.0166 300.608 92.1393 300.599 94.7638Z",
    fill: "#C6DD85"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M168.367 113.501C170.448 113.502 172.29 112.151 172.914 110.166C173.538 108.18 172.801 106.019 171.093 104.829L165.121 112.218C166 113.044 167.161 113.503 168.367 113.501Z",
    fill: "#C6DD85"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.783,
    cy: 108.737,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.209,
    cy: 108.737,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.47,
    cy: 108.737,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.888,
    cy: 108.737,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.313,
    cy: 108.737,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.729,
    cy: 108.737,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.149,
    cy: 108.737,
    r: 4.76395,
    fill: "#C6DD85"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.6022,
    cy: 42.3268,
    r: 5.22524,
    fill: "#32B8ED"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5007,
    cy: 65.1487,
    r: 2.53294,
    fill: "#E8E8A3"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.4365,
    cy: 83.0386,
    r: 1.04002,
    fill: "#ADC7DB"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.1626,
    cy: 81.4531,
    r: 0.662591,
    fill: "#ADC7DB"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.0228,
    cy: 68.3275,
    r: 0.645817,
    fill: "#ADC7DB"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.3959,
    cy: 53.3812,
    r: 1.3168,
    fill: "#ADC7DB"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.2994,
    cy: 31.7506,
    r: 4.55427,
    fill: "#ADC7DB"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.036,
    cy: 60.3428,
    r: 2.55811,
    fill: "#E8E8A3"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.838,
    cy: 87.727,
    r: 2.17229,
    fill: "#FF92B9"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.2123,
    cy: 93.246,
    r: 0.318715,
    fill: "#ADC7DB"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.342,
    cy: 68.1176,
    r: 1.74454,
    fill: "#E8E8A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSetupDisplay);
export default __webpack_public_path__ + "static/media/account-setup-display.922172dd66270803973ff6f1566c91b6.svg";
export { ForwardRef as ReactComponent };